// Diagnostics stay hidden until the tilde key reveals them —
// the same key that toggles inspect mode in loop mode, so ` means
// "dev view" everywhere. The M/C shortcuts still work while hidden.
const DEV_IDS = ["stats"];

export function installDevUi(): void {
  const els = DEV_IDS
    .map((id) => document.getElementById(id))
    .filter((el): el is HTMLElement => el !== null);
  let shown = false;
  const apply = () => {
    for (const el of els) el.style.display = shown ? "" : "none";
  };
  apply();
  addEventListener("keydown", (e) => {
    const target = e.target as HTMLElement | null;
    if (
      target?.isContentEditable || target?.closest("input, textarea, select")
    ) return;
    if (e.code === "Backquote") {
      shown = !shown;
      apply();
    }
  });
}
